export default class Provider {
  constructor (data) {
    this.id = data.id
    this.name = data.name
  }
}
